/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Channel_Not_AllowedInputs */

const vi_error_shop_channel_not_allowed = /** @type {(inputs: Error_Shop_Channel_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kênh bán này không dùng được chức năng này.`)
};

/**

* @param {Error_Shop_Channel_Not_AllowedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_channel_not_allowed = /** @type {((inputs?: Error_Shop_Channel_Not_AllowedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Channel_Not_AllowedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_channel_not_allowed(inputs)
});